export const getDefaultCloudinaryAnalyticsParams = () => {
  const [, cloud, delivery] = window.location.pathname.split('/');
  return { domain: window.location.hostname, cloud, delivery };
};
